module.exports = __webpack_public_path__ + "img/climate_actions_ebike@2x.cf1a672.webp";